import axiosInstance from '@/core/api'

import type {
	TelegramNotifySettingResponse,
	UpdateTelegramNotifySettingDto,
} from '../../types'

export const getTelegramNotifySetting =
	async (): Promise<TelegramNotifySettingResponse> => {
		const response = await axiosInstance.get<TelegramNotifySettingResponse>(
			'/admin/telegram-notify',
		)
		return response.data
	}

export const updateTelegramNotifySetting = async (
	payload: UpdateTelegramNotifySettingDto,
): Promise<TelegramNotifySettingResponse> => {
	const response = await axiosInstance.patch<TelegramNotifySettingResponse>(
		'/admin/telegram-notify',
		payload,
	)
	return response.data
}
